import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

interface CoursesData {
  course: {
    id: string;
    name: string;
    slug: string;
    description: string;
    part: string;
    InstructorId: string;
    img_url: string;
    num_hours: string;
    actualPrice_egp: string;
    actualPrice_usd: string;
    discountPrice_egp: string;
    discountPrice_usd: string;
    discountPercentage: string;
    preview_video: string;
    isTrending: boolean;
    borchure_url: string;
    createdAt: string;
    updatedAt: string;
    categoryId: string;
    parentCourseId: string;
    packageId: string;
    quizzes: {
      id: string;
      title: string;
    }[];
  };
}
interface CoursesResponse {
  data?: CoursesData;
  error?: ApiError;
}

export const GetAllCourseQuizzes = async (
  courseId: string
): Promise<CoursesResponse> => {
  try {
    const response = await axios.get(`/course/course-quizzes/${courseId}`);

    return { data: { course: response.data } };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
